import bodymovin from 'lottie-web';

import Component from '../component';
import firework from './animations/firework.json';
import sparkle from './animations/sparkle.json';
import star from './animations/star.json';

export default class LottieAnimation extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.loadAnimation();
  }

  unbindEvents() {
    this.animation.destroy();
  }

  loadAnimation() {
    this.animation = bodymovin.loadAnimation({
      container: this.$element[0],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: this.__animation(),
    });
  }

  __animation() {
    switch (this.$element.data('animation')) {
      case 'firework':
        return firework;
      case 'sparkle':
        return sparkle;
      case 'star':
        return star;
      default:
        return null;
    }
  }
}
